import React, { useEffect, useState } from 'react'
import Header from '../include/Header'
import Sidebar from '../include/Sidebar'
import { Link, useLocation, useNavigate } from 'react-router-dom';

import City from '../../../city.json';
import { PAY_URL } from '../../../BaseURL';
import toast from 'react-hot-toast';
import axios from 'axios';

const ManageFirm = () => {


    const [firm, setFirm] = useState({
        register_no: "",
        name: "",
        email: "",
        phone: "",
        address: "",
        address_two: "",
        address_three: "",
        pincode: "",
        image: "",
    });

    const [disable, setDisable] = useState(false);
    const [selectedState, setSelectedState] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [error, setError] = useState({});

    const [selectValue, setSelectValue] = useState('');

    const data = location.state;

    // console.log(data, '@@');

    useEffect(() => {
        if (localStorage.getItem('PAY_ADMIN_TOKEN') === null) {
            navigate("/admin/login");
        }
    }, []);

    useEffect(() => {

        setFirm({
            register_no: data?.register_no,
            name: data?.name,
            email: data?.email,
            phone: data?.mobile_number,
            address: data?.address,
            address_two: data?.address_two,
            address_three: data?.address_three,
            pincode: data?.pincode,
            image: data?.image,
        });

        setSelectedCity(data?.city);
        setSelectedState(data?.state);
        setSelectValue(data?.status);

    }, [location.state])

    const handleStateChange = (e) => {
        const selectedState = e.target.value;
        setSelectedState(selectedState);
        setSelectedCity('');
    };

    const handleCityChange = (e) => {
        const selectedCity = e.target.value;
        setSelectedCity(selectedCity);
    };


    const defaultCountry = City.find((c) => c.iso2 === 'IN');
    const states = defaultCountry ? defaultCountry.states : [];
    const cities = states.find((s) => s.name === selectedState)?.cities || [];

    const handleChange = (e) => {
        setFirm({ ...firm, [e.target.name]: e.target.value });
    }

    const handleRadioChange = (event) => {
        setSelectValue(event.target.checked);
    };

    const handleImage = (e) => {
        if (e?.target?.files[0]) {
            const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];
            const fileType = e.target.files[0].type;

            if (allowedTypes.includes(fileType)) {
                // setFirm({ ...firm, image: URL.createObjectURL(e?.target?.files[0]) })
                setDisable(true);
                const myurl = `${PAY_URL}/upload-image`;
                var bodyFormData = new FormData();
                bodyFormData.append("image", e?.target?.files[0]);

                axios({
                    method: "post",
                    url: myurl,
                    data: bodyFormData,
                })
                    .then((result) => {
                        // console.log("=====", result);

                        if (result?.data?.success === true) {
                            setFirm({ ...firm, image: result?.data?.data?.image });
                            setDisable(false);
                        } else {
                            // console.log("Error:=====");
                            setFirm({ ...firm, image: "" });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        setFirm({ ...firm, image: "" });
                        setDisable(false);
                        toast.error("Unable to upload image");
                    });
            } else {
                setFirm({ ...firm, image: "" });
                setDisable(false);
                toast.error("Invalid file type. Only JPEG, JPG, and PNG are allowed.");
            }
        }
    };

    const handleSubmit = () => {
        if (validation()) {
            setDisable(true);

            const bodyFormData = new URLSearchParams();
            bodyFormData.append('register_no', firm.register_no);
            bodyFormData.append('name', firm.name);
            bodyFormData.append('email', firm.email);
            bodyFormData.append('address', firm.address);
            bodyFormData.append('address_two', firm.address_two);
            bodyFormData.append('address_three', firm.address_three);
            bodyFormData.append('state', selectedState);
            bodyFormData.append('city', selectedCity);
            bodyFormData.append('pincode', firm.pincode);
            bodyFormData.append('mobile_number', firm.phone);
            bodyFormData.append('image', firm.image);
            if (data?._id) {
                bodyFormData.append('id', data._id)
                bodyFormData.append('status', selectValue)
            }

            axios({
                method: 'post',
                url: `${PAY_URL}/admin/manage-firm`,
                data: bodyFormData,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: "Bearer " + localStorage.getItem('PAY_ADMIN_TOKEN') }
            }).then((response) => {
                // console.log(response);
                if (response.data.success === true) {
                    toast.success(response.data.message)
                    navigate('/admin/firm-management');
                    setFirm({
                        register_no: "",
                        name: "",
                        email: "",
                        phone: "",
                        address: "",
                        address_two: "",
                        address_three: "",
                        pincode: "",
                        image: ""
                    })
                    setDisable(false);
                }
            }).catch((error) => {
                console.log(error);
                toast.error(error.response.data.message);
                setDisable(false);
            })
        }
    }

    const handleReset = () => {
        setFirm({
            register_no: "",
            name: "",
            email: "",
            phone: "",
            address: "",
            address_two: "",
            address_three: "",
            pincode: "",
            image: ""
        });
        setSelectedCity('');
        setSelectedState('');
    }


    const validation = () => {
        let isValid = true;
        let err = {};

        if (!firm.name || !firm.name.trim()) {
            isValid = false;
            err['name_err'] = "Please enter name"
        }

        if (!firm.register_no || !firm.register_no.trim()) {
            isValid = false;
            err['register_no_err'] = "Please enter register no."
        }

        if (!firm.address) {
            isValid = false;
            err['address_err'] = "Please enter address"
        }

        if (!firm.email) {
            isValid = false;
            err['email_err'] = "Please enter email"
        } else if (typeof firm.email !== "undefined") {
            let lastAtPos = firm.email.lastIndexOf('@');
            let lastDotPos = firm.email.lastIndexOf('.');

            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && firm.email.indexOf('@@') === -1 && lastDotPos > 2 && (firm.email.length - lastDotPos) > 2)) {
                isValid = false;
                err["email_err"] = "Email is not valid";
            }
        }

        if (!firm.phone) {
            isValid = false;
            err["phone_err"] = "Please enter mobile";
        } else if (!/^\d{10}$/.test(firm.phone)) {
            isValid = false;
            err['phone_err'] = 'Please enter a valid mobile';
        }

        if (!selectedState) {
            isValid = false;
            err['state_err'] = "Please select state"
        }

        if (!selectedCity) {
            isValid = false;
            err['city_err'] = "Please select city"
        }

        if (!firm.pincode) {
            isValid = false;
            err['pincode_err'] = "Please enter pincode"
        }

        if (!firm.image) {
            isValid = false;
            err['image_err'] = "Please select image"
        }

        setError(err);
        return isValid
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <>
            <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
                <Header handleOpen={handleOpen} />
                <Sidebar />
                <div className="page-wrapper">
                    <div className="content container-fluid">
                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title">{data?._id ? 'Edit' : 'Add'} Firm</h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/admin/dashboard">Dashboard</Link></li>
                                        <li className="breadcrumb-item"><Link to='/admin/firm-management'>Firm Management</Link></li>
                                        <li className="breadcrumb-item active">{data?._id ? 'Edit' : 'Add'} Firm</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="card p-3 basicform">
                            {/* <div className=" mb-3 titleForm border-bottom">
                                <h4 className="">Add Firm</h4>
                            </div> */}
                            <div className="row card_id">
                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="firmName" className="form-label">Name</label>
                                            <input type="text" className="form-control" id="firmName"
                                                value={firm.name}
                                                name='name' onChange={handleChange} />
                                            <div className='error'>{error.name_err}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="firmRegister" className="form-label">Register No.</label>
                                            <input type="text" className="form-control" id="firmRegister"
                                                name='register_no' value={firm.register_no} onChange={handleChange}
                                            />
                                            <div className='error'>{error.register_no_err}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row card_id">
                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="address1" className="form-label">Address</label>
                                            <input type='text'
                                                name='address' onChange={handleChange} value={firm.address}
                                                className="form-control" id="address1" />
                                            <div className='error'>{error.address_err}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="address2" className="form-label">Address 2</label>
                                            <input type='text' className="form-control"
                                                onChange={handleChange} value={firm.address_two} name='address_two'
                                                id="address2" />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="address3" className="form-label">Address 3</label>
                                            <input type='text' className="form-control" id="address2"
                                                name='address_three' value={firm.address_three} onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row card_id">
                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="state" className="form-label">State</label>
                                            <select className="form-select form-control"
                                                value={selectedState}
                                                onChange={handleStateChange} name='state'
                                                aria-label="Default select example">
                                                <option value="">Select State</option>
                                                {states.map((state) => (
                                                    <option key={state.name} value={state.name}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                            </select>
                                            <div className='error'>{error.state_err}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="city" className="form-label">City</label>
                                            <select className="form-select form-control"
                                                value={selectedCity}
                                                onChange={handleCityChange}
                                                disabled={!selectedState}
                                                name='city'
                                                aria-label="Default select example">
                                                <option value="">Select City</option>
                                                {cities.map((city) => (
                                                    <option key={city.id} value={city.name}>
                                                        {city.name}
                                                    </option>
                                                ))}
                                            </select>
                                            <div className='error'>{error.city_err}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="firmPincode" className="form-label">Pincode</label>
                                            <input type="number" className="form-control" id="firmPincode"
                                                value={firm.pincode} name='pincode' onChange={handleChange}
                                            />
                                            <div className='error'>{error.pincode_err}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row card_id">
                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="firmEmail" className="form-label">Email</label>
                                            <input type="email"
                                                name='email' onChange={handleChange} value={firm.email}
                                                className="form-control" id="firmEmail" />
                                            <div className='error'>{error.email_err}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="firmPhone" className="form-label">Mobile</label>
                                            <input type="number"
                                                name='phone' value={firm.phone} onChange={handleChange}
                                                className="form-control" id="firmPhone" />
                                            <div className='error'>{error.phone_err}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="row card_id">
                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="fileUpload" className="form-label">Images</label>
                                            <input type="file" className="form-control" id="fileUpload" onChange={handleImage} />
                                            {firm.image ? <img src={firm.image} alt='firm-image' style={{ height: '130px', objectFit: 'cover', borderRadius: '10px', marginTop: "10px" }} /> : ""}
                                            <div className='error'>{error.image_err}</div>
                                        </div>
                                    </div>
                                </div>
                                {data?._id ? (
                                    <div className='col-md-4 col-lg-4 col-xxl-4 col-sm-12'>
                                        <div className="cardNum">
                                            <div className="mb-3">
                                                <label htmlFor="fileUpload" className="form-label">Status</label>
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input" type="checkbox" role="switch" onChange={handleRadioChange} checked={selectValue} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </div>

                            <div className="row card_id mt-4 sm-mt-3">
                                <div className=" col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3 d-flex gap-2">
                                            <button className="btn btn-primary w-50" type='button' onClick={handleSubmit} disabled={disable}>{disable ? "Processing..." : (data?._id ? 'Update' : 'Submit')}</button>
                                            <button className="btn btn-outline-secondary w-50" onClick={handleReset}>Reset</button>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ManageFirm